(function() {
  function baseLabel(text) {
    return String(text || '').replace(/\s*\(nicht verfügbar\)\s*$/i, '');
  }

  function readSelected(section, product) {
    const result = {};
    // Fieldsets bevorzugen
    section.querySelectorAll('fieldset').forEach(fs => {
      const legend = fs.querySelector('legend')?.textContent?.trim();
      if (!legend) return;
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) result[legend] = checked.value.trim();
      const sel = fs.querySelector('select');
      if (sel) result[legend] = sel.value.trim();
    });
    // generische selects
    section.querySelectorAll('select[name^="options["]').forEach(sel => {
      const m = sel.name.match(/^options\[(.+)\]$/);
      const key = m ? m[1] : sel.name;
      if (!(key in result)) result[key] = sel.value.trim();
    });
    return result;
  }

  function refreshSelect(section, product, optionName) {
    const select = section.querySelector(`select[name="options[${CSS.escape(optionName)}]"]`);
    if (!select) return;

    const opts = readSelected(section, product);

    const pos = product.options.findIndex(n => (n||'').toLowerCase() === optionName.toLowerCase()); // 0/1/2
    if (pos === -1) return;

    const othersComplete = product.options
      .filter((_, idx) => idx !== pos)
      .every(name => (opts[name] || '').trim() !== '');

    Array.from(select.options).forEach(optEl => {
      const value = optEl.value;
      const label = baseLabel(optEl.textContent);
      let matchedAny = false;
      let availableAny = false;

      for (const v of product.variants) {
        let ok = true;
        const want = [];
        want[0] = (pos === 0) ? value : (opts[product.options[0]] || '');
        want[1] = (pos === 1) ? value : (product.options[1] ? (opts[product.options[1]] || '') : '');
        want[2] = (pos === 2) ? value : (product.options[2] ? (opts[product.options[2]] || '') : '');

        if (product.options.length >= 1 && want[0] && v.option1 !== want[0]) ok = false;
        if (ok && product.options.length >= 2 && want[1] && v.option2 !== want[1]) ok = false;
        if (ok && product.options.length >= 3 && want[2] && v.option3 !== want[2]) ok = false;

        if (ok) {
          matchedAny = true;
          if (v.available) availableAny = true;
        }
      }

      let showSuffix = false;
      if (othersComplete) {
        if (matchedAny) {
          if (!availableAny) showSuffix = true;
        } else {
          showSuffix = true;
        }
      }

      optEl.textContent = showSuffix ? `${label} (nicht verfügbar)` : label;
      optEl.dataset.unavailable = String(showSuffix);
    });
  }

  function initSection(section) {
    const sid = section.dataset.sectionId;
    const el = document.getElementById(`ProductJson-${sid}`);
    if (!el) return;
    let product;
    try { product = JSON.parse(el.textContent); } catch(e) { return; }
    if (!product) return;

    // Größen-Option heuristisch finden (DE/EN), sonst zweite/erste Option
    const sizeName = product.options.find(n => /größe|groesse|size/i.test(n)) || product.options[1] || product.options[0];

    function run() { refreshSelect(section, product, sizeName); }
    run();

    section.addEventListener('change', run);
    document.addEventListener('product:variant-change', (e) => {
      const origin = e.target?.closest?.('.product[data-section-id]');
      if (origin && origin !== section) return;
      run();
    });
  }

  function boot(root=document) {
    root.querySelectorAll('.product[data-section-id]').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', () => boot(document));
  document.addEventListener('shopify:section:load', (e) => {
    const container = e.target || e.detail?.section;
    if (container) boot(container);
  });
})();


(function(){
  function baseLabel(t){ return String(t||'').replace(/\s*\(nicht verfügbar\)\s*$/i,''); }

  function readSelected(section){
    const out = {};
    section.querySelectorAll('fieldset').forEach(fs=>{
      const name = fs.querySelector('legend')?.textContent?.trim();
      if(!name) return;
      const checked = fs.querySelector('input[type="radio"]:checked');
      if(checked) { out[name]=checked.value.trim(); return; }
      const sel = fs.querySelector('select');
      if(sel) out[name]=sel.value.trim();
    });
    section.querySelectorAll('select[name^="options["]').forEach(sel=>{
      const m = sel.name.match(/^options\[(.+)\]$/); const key = m?m[1]:sel.name;
      if(!(key in out)) out[key]=sel.value.trim();
    });
    return out;
  }

  function refresh(section){
    const sid = section.dataset.sectionId;
    const el = document.getElementById(`ProductJson-${sid}`);
    if(!el) return;
    let product; try{ product=JSON.parse(el.textContent); }catch(e){ return; }
    if(!product) return;

    // Größen-Select finden
    const sizeName = product.options.find(n=>/größe|groesse|size/i.test(n)) || product.options[1] || product.options[0];
    const select = section.querySelector(`select[name="options[${CSS.escape(sizeName)}]"]`);
    if(!select) return;

    const mode = select.querySelector('option')?.dataset?.unavailableMode || 'disable';
    const opts = readSelected(section);
    const pos = product.options.findIndex(n=>(n||'').toLowerCase()===sizeName.toLowerCase());
    const othersComplete = product.options.filter((_,i)=>i!==pos).every(n=>(opts[n]||'')!=='');

    const options = Array.from(select.options);
    options.forEach(o=>{
      const val = o.value;
      const label = baseLabel(o.textContent);
      let matched=false, available=false;

      for(const v of product.variants){
        let ok=true;
        const want=[ '', '', '' ];
        if(product.options[0]) want[0] = (pos===0)?val:(opts[product.options[0]]||'');
        if(product.options[1]) want[1] = (pos===1)?val:(opts[product.options[1]]||'');
        if(product.options[2]) want[2] = (pos===2)?val:(opts[product.options[2]]||'');

        if(product.options[0] && want[0] && v.option1!==want[0]) ok=false;
        if(ok && product.options[1] && want[1] && v.option2!==want[1]) ok=false;
        if(ok && product.options[2] && want[2] && v.option3!==want[2]) ok=false;
        if(ok){ matched=true; if(v.available) available=true; }
      }

      const mark = othersComplete ? (!matched || !available) : false;

      if(mode==='hide'){
        // verstecken/zeigen
        o.hidden = !!mark;
        // falls aktuell ausgewählte Option gerade versteckt wurde → erste sichtbare wählen
        if(o.hidden && o.selected){
          const firstVisible = options.find(x=>!x.hidden);
          if(firstVisible){ select.value = firstVisible.value; select.dispatchEvent(new Event('change',{bubbles:true})); }
        }
      }else{
        // disable + Label
        o.disabled = !!mark;
        o.textContent = mark ? `${label} (nicht verfügbar)` : label;
      }
    });
  }

  function boot(root=document){
    root.querySelectorAll('.product[data-section-id]').forEach(section=>{
      const run = ()=>refresh(section);
      run();
      section.addEventListener('change', run);
      document.addEventListener('product:variant-change', e=>{
        const origin = e.target?.closest?.('.product[data-section-id]');
        if(origin && origin!==section) return;
        run();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', ()=>boot(document));
  document.addEventListener('shopify:section:load', e=>{
    const el = e.target || e.detail?.section; if(el) boot(el);
  });
})();